<div class="layout-container" [ngClass]="responsive.screenClass | async">
    <app-nav
        class="top-nav"
        [isCollapsed]="isCollapsed"
        (collapseChanged)="isCollapsed = $event"
    ></app-nav>
    <div class="layout-body">
        <app-sidenav
            class="side-nav"
            [class.expanded]="isCollapsed"
            [isCollapsed]="isCollapsed"
            (collapseChanged)="isCollapsed = $event"
        ></app-sidenav>
        <div class="bodycontent" [class.expanded]="!isCollapsed">
            <div class="router-container" #scrollContainer>
                <router-outlet></router-outlet>
            </div>
            <!-- <div class="align-con-cen text-grey">© 2024 AethyrTech.ai. All rights reserved.</div> -->
        </div>
    </div>
</div>
